import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { EventListeningDisposer, IEventBus } from '../../../../../services/eventBus.service';
import { IAnnotationsStore } from '../../../annotations.store';
import { ClarificationAddedEvent, ClarificationAddedEventType } from '../events/ClarificationAddedEvent';
import { IClarificationsBl } from '../services/Clarifications.bl';
import { CurrentClarificationContainer } from './CurrentClarification.container';

export const ClarificationsContainer = observer((): ReactElement => {
  const clarificationsBl = useInjection(IClarificationsBl.$);
  const annotationsStore = useInjection(IAnnotationsStore.$);
  const eventBus = useInjection(IEventBus.$);

  const { projectId } = useParams<{ projectId: string }>();
  const clarificationAddedDisposer = useRef<EventListeningDisposer>(null);

  useEffect(() => {
    clarificationAddedDisposer.current = eventBus.addListener<ClarificationAddedEvent>(handleClarificationAdded, ClarificationAddedEventType);

    return (): void => {
      clarificationAddedDisposer.current?.();
      annotationsStore.image = undefined;
      clarificationsBl.dispose();
    };
  }, []);

  useEffect(() => {
    void getClarifications();
  }, [annotationsStore.image]);

  const getClarifications = async (): Promise<void> => {
    if (annotationsStore.image) {
      await clarificationsBl.getClarificationsAsync(projectId, annotationsStore.image.id);
    }
  };

  const handleClarificationAdded = async (): Promise<void> => {
    await getClarifications();
  };

  return (
    <div className='image-clarifications'>
      <CurrentClarificationContainer />
    </div>
  );
});
